import invariant from 'tiny-invariant';
import { DoneMessage, RequestMessage } from './types';

/**
 * Функция используется для быстрой проверки что все возможные кейсы в типе-сумме (Discriminated Union/ Tagged Union) были обработаны.
 * @see https://www.typescriptlang.org/docs/handbook/2/everyday-types.html#working-with-union-types
 * @see https://basarat.gitbook.io/typescript/type-system/discriminated-unions
 * @example
 * interface Square {
    kind: "square";
    size: number;
}

interface Rectangle {
    kind: "rectangle";
    width: number;
    height: number;
}
type Shape = Square | Rectangle;

function getArea(shape: Shape) {
  if (shape.kind === "square") return shape.size**2;
  if (shape.kind === "reactabgle") return shape.width * shape.height;
  // Если мы добавим в Shape ещё один тип, TS уведомит нас что тут ошибка
  // Если TS не уведомил, а функция была вызвана - ошибка в исходных типах
  return discriminatedUnionAttentionNeeded(shape);
}
 */
export function discriminatedUnionAttentionNeeded(
  arg: never
): asserts arg is never {
  console.trace(arg);
  throw new Error(
    'Поскольку эта ошибка не была поймана на этапе проверки типов - в типах ошибка'
  );
}

export function isDoneMessage(message: any): asserts message is DoneMessage {
  invariant(message && message.type && message.type === 'done');
}

export function isRequestMessage(message: {
  type: string;
}): asserts message is RequestMessage {
  invariant(
    message.type === 'delete' ||
      message.type === 'load' ||
      message.type === 'save'
  );
}
